import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-model',
  templateUrl: './download-model.component.html',
  styleUrls: ['./download-model.component.css']
})
export class DownloadModelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
